import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, ValidateNested } from "class-validator";
import { ChildEntity } from "../../entity";

export class GetParentChildrenDTO {
  @Expose()
  @ValidateNested()
  @IsArray()
  @Type(() => ChildEntity)
  data!: ChildEntity[];

  @Expose()
  @IsNumber()
  count!: number;

  @Expose()
  @IsNumber()
  page!: number;

  @Expose()
  @IsNumber()
  pageSize!: number;
}
